<template>
  <div class="category-edit">
    <div class="container">

      <el-form :model="form" :rules="rules" ref="form" label-width="80px">

        <el-form-item>
          <el-button @click="goBack">返回</el-button>
          <el-button type="primary" @click="save" :loading="saving">保存</el-button>
        </el-form-item>
        
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入分类名称" :maxlength="20"></el-input>
        </el-form-item>
        
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="1" :max="999" placeholder="请输入排序"></el-input-number>
        </el-form-item>

      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CategoryEdit',
  data() {
    return {
      saving: false,
      loading: false,
      form: {
        id: 0,
        name: '',
        sort: 1
      },
      rules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: ['blur', 'change'] },
          { type: 'number', min: 1, max: 999, message: '排序值必须在1-999之间', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    isEdit() {
      return this.$route.params.id !== 'add';
    }
  },
  created() {
    if (this.isEdit) {
      this.loadCategoryDetail();
    } else {
      // 新增模式下，确保默认值正确设置
      this.$nextTick(() => {
        this.form.sort = 1;
      });
    }
  },
  methods: {
    async loadCategoryDetail() {
      this.loading = true;
      try {
        const response = await this.$http({
          method: 'GET',
          url: this.$util.domain + '/adminapi/v1/courseType/detail',
          params: { id: this.$route.params.id }
        });
        
        if (response.data.error === 10000) {
          const data = response.data.data;
          this.form = {
            id: data.id,
            name: data.name,
            sort: data.sort
          };
        } else {
          this.$message.error(response.data.message || '获取分类详情失败');
          this.goBack();
        }
      } catch (error) {
        console.error('获取分类详情失败:', error);
        this.$message.error('获取分类详情失败，请检查网络连接');
        this.goBack();
      } finally {
        this.loading = false;
      }
    },
    
    goBack() {
      this.$router.go(-1);
    },

    save() {
      console.log('save方法被调用了');  // 添加方法入口日志
      
      console.log('开始表单验证');
      console.log('表单引用:', this.$refs.form);
      console.log('表单数据:', this.form);
      
      this.$refs.form.validate((valid) => {
        console.log('表单验证结果:', valid);
        
        if (!valid) {
          console.log('表单验证失败，退出保存');
          return;
        }
        
        this.saving = true;
        console.log('设置保存状态为true');
        
        const requestData = {
          id: this.isEdit ? this.form.id : 0,
          name: this.form.name,
          sort: this.form.sort,
          status: 1  // 默认设置为上架状态
        };
        
        console.log('保存数据:', requestData);  // 添加调试日志
        
        // 使用项目标准的$http方法而不是axios
        this.$http({
          method: 'POST',
          url: this.$util.domain + '/adminapi/v1/courseType/addOrEdit',
          body: JSON.stringify(requestData)
        }).then(response => {
          console.log('API响应:', response.data);  // 添加调试日志
          
          if (response.data.error === 10000) {
            this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
            this.goBack();
          } else {
            this.$message.error(response.data.message || '保存失败');
          }
        }).catch(error => {
          console.error('保存失败:', error);
          this.$message.error('保存失败，请检查网络连接');
        }).finally(() => {
          console.log('重置保存状态');
          this.saving = false;
        });
      });
    }
  }
}
</script>

<style scoped>
.category-edit {
  padding: 20px;
}

.container {
  max-width: 500px;
  background: white;
  padding: 30px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h3 {
  margin: 0 0 30px 0;
  color: #333;
}

.el-form-item:last-child {
  margin-bottom: 0;
}

.el-button {
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// categoryEdit.vue?4504de17